import {
  ApiDelete,
  ApiGet,
  ApiPostNew,
  ApiPut
} from '../../../services/apiService';

import Swal from 'sweetalert2';

export async function perguntaSubareaPost(data) {
  try {
    const response = await ApiPostNew('/v1/perguntaSubarea', data);
    if (response.data.mensagem.msg.slice(0, 3) === '100') {
      return true;
    }
    alert(response.data.mensagem.msg);
    return false;
  } catch (err) {
    console.log(err);
  }
}

export async function perguntaSubareaUpdate(data) {
  try {
    const response = await ApiPut(
      '/v1/perguntaSubarea',
      data,
      localStorage.getItem('sessionToken')
    );
    if (response.data.mensagem.msg.slice(0, 3) === '100') {
      alert('Registro atualizado com sucesso!');
      return true;
    }
    alert(response.data.mensagem.msg);
    return false;
  } catch (err) {
    console.log(err);
  }
}

export async function perguntaSubareaDelete(data) {
  await Swal.fire({
    title: 'Deletar registro?',
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#3085d6',
    cancelButtonColor: '#d33',
    confirmButtonText: 'Confirmar'
  }).then(async (result) => {
    if (result.isConfirmed) {
      try {
        const response = await ApiDelete(
          '/v1/perguntaSubarea',
          data,
          localStorage.getItem('sessionToken')
        );
        if (response.data.mensagem.msg.slice(0, 3) === '100') {
          alert('Registro deletado com sucesso!');
          return true;
        }
        alert(response.data.mensagem.msg);
        return false;
      } catch (err) {
        console.log(err);
      }
    }
  });
}

export async function perguntaSubareaSelect(dataFiltro) {
  try {
    const response = await ApiGet(
      '/v1/perguntaSubarea',
      dataFiltro,
      localStorage.getItem('sessionToken')
    );
    return response?.data?.dados;
  } catch (err) {
    console.log(err);
  }
}
